import { Trans, useLingui } from '@lingui/react'
import { type FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { TENANT_COM } from 'shared/consts'
import { putCollectiveOrderAction } from 'shared/store/ducks/cart'
import Notification from 'views/components/molecules/Notification'
import CollectiveOrderCheckBox from 'views/components/organisms/Cart/CollectiveOrderCheckBox'
import CollectiveOrderModal from 'views/components/organisms/Cart/CollectiveOrderModal'
import { COLLECTIVE_ORDER_MODAL } from 'views/components/organisms/Cart/CollectiveOrderModal/const'
import { useMaxDosageValues } from 'views/components/organisms/Cart/hooks/useMaxDosageValues'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import scrollToTop from 'views/utils/scrollToTop'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

const labelCollectiveAndIndivualLimitReached = (
  showCollectiveOrderSelection: boolean
) => (
  <>
    <Trans id="cart.notification.maxDosage.warning.limitedQuantityPleaseReduce" />
    <u
      data-a11y-dialog-show={COLLECTIVE_ORDER_MODAL}
      className="u-margin-xx-small--left m-NotificationCollectiveOrderWarning__more-info"
      style={{ cursor: 'pointer' }}
    >
      <Trans id="general.more.information.short" />
    </u>
    {showCollectiveOrderSelection && (
      <>
        <br />
        <br />
        <Trans id="cart.notification.maxDosage.warning.ifIsCollectiveOrderPleaseSelect" />
      </>
    )}
  </>
)
const NotificationCollectiveOrderWarning: FC = () => {
  const { i18n } = useLingui()
  const dispatch = useDispatch()
  const { tenant } = usePublicConfig()
  useEffect(() => scrollToTop('smooth'), [])
  const showCollectiveOrderSelection = tenant !== TENANT_COM

  const { isCollectiveOrderStatus, isForMaxDosageLoggedInUser } =
    useMaxDosageValues()

  const labelDefault = (
    <div data-qa-id="cart-overdraft-notification-header">
      <div className="l-flex">
        <strong className="m-NotificationCollectiveOrderWarning__title">
          <Trans id="cart.notification.maxDosage.cartInfoBox.info.title" />
        </strong>
      </div>
      <br />
      <TransWithHtml
        text={i18n._('cart.notification.maxDosage.cartInfoBox.info.text')}
        className="m-NotificationCollectiveOrderWarning__text"
      />{' '}
      <br />
      <br />
      <strong className="m-NotificationCollectiveOrderWarning__title">
        <Trans id="cart.notification.maxDosage.cartInfoBox.info.subSection.title" />
      </strong>{' '}
      <br className="u-hidden@small-tiny" />
      <TransWithHtml
        text={i18n._(
          'cart.notification.maxDosage.cartInfoBox.info.subSection.text'
        )}
        className="m-NotificationCollectiveOrderWarning__text"
      />
      <u
        data-a11y-dialog-show={COLLECTIVE_ORDER_MODAL}
        className="u-margin-xx-small--left m-NotificationCollectiveOrderWarning__more-info"
        style={{ cursor: 'pointer' }}
      >
        <Trans id="general.more.information.short" />
      </u>
      {showCollectiveOrderSelection && (
        <CollectiveOrderCheckBox
          onCheckBoxClick={() =>
            dispatch(putCollectiveOrderAction(!isCollectiveOrderStatus))
          }
          isCollectiveOrderStatus={isCollectiveOrderStatus}
          className="u-padding-small--top"
        />
      )}
    </div>
  )

  return (
    <>
      <div className="l-content u-padding-large--left u-padding-large--right u-padding-large--top m-NotificationCollectiveOrderWarning">
        {isForMaxDosageLoggedInUser ? (
          <Notification
            label={labelCollectiveAndIndivualLimitReached(
              showCollectiveOrderSelection
            )}
            type="attention"
          />
        ) : (
          <Notification label={labelDefault} type="attention" />
        )}
      </div>
      <CollectiveOrderModal />
    </>
  )
}

export default NotificationCollectiveOrderWarning
